import React from 'react';
import {Link} from "react-router-dom";
import arrowIcon from "../../assets/icons/arrow.png";
import routes from "../../routes/routes";

const PropositionSection = () => {
    return (
        <div className="w-full px-4 py-6 md:py-8">
            {/* Conteneur principal avec centrage sur tous les écrans */}
            <div className="max-w-3xl mx-auto">
                {/* Titre - centré sur tous les écrans */}
                <h2 className="flex items-center justify-center text-2xl sm:text-3xl lg:text-4xl font-semibold text-greenlogo">
                    <span className="w-8 sm:w-10 lg:w-16 h-1.5 sm:h-2 lg:h-2.5 mt-2 bg-greenlogo mr-2"></span>
                    Proposer un article
                </h2>

                {/* Contenu principal avec bordure fine - centré sur tous les écrans */}
                <div className="py-6">
                    {/* Sous-titre */}
                    <p className="text-center font-light text-gray-600 mb-4">
                        Partagez vos découvertes avec la communauté MADATLAS
                    </p>

                    {/* Texte principal avec meilleure lisibilité */}
                    <p className="text-gray-700 text-justify leading-relaxed mb-8 px-0 sm:px-2 mx-auto">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                        labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
                        nisi ut aliquip ex ea commodo consequat
                    </p>

                    {/* Bouton avec design plus subtil */}
                    <div className="flex justify-center mb-6">
                        <Link to={routes.proposition} className="bg-greenlogo font-semibold w-full sm:w-auto text-white px-3 sm:px-5 py-4 sm:py-4.5 flex items-center justify-center sm:justify-start text-md sm:text-md">
                            Publier dans Madatlas
                            <img src={arrowIcon} className="ml-3 h-4 w-auto" alt="Voir plus" />
                        </Link>
                    </div>

                    {/* Lien avec style minimaliste */}
                    <div className="text-center">
                        <Link to="/politique-de-publication" className="text-greenprimary text-md underline">
                            Politique de publication
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PropositionSection;